
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.5 37C28.719 37 37 28.717 37 18.5S28.719 0 18.5 0 0 8.283 0 18.5 8.281 37 18.5 37zM29.582 8.153h-3.68l-6.066 6.933-5.242-6.932H7l9.074 11.863-8.601 9.83h3.683l6.637-7.584 5.8 7.584H31l-9.46-12.503 8.042-9.19zm-2.934 19.492H24.61L11.297 10.24h2.187l13.164 17.404z","fill":"#FEFEFE"}})])
          )
        }
      }
    